import styled from "styled-components";
import { DESKTOP } from "common/constants/breakpoints";

import Container from "../../styled-components/Container";

export default styled(Container)`
  gap: 15px;

  @media screen and (min-width: ${DESKTOP}px) {
    gap: 20px;
  }
`;
